import React, { Suspense, useEffect } from "react";
import "./App.css";
import Layout from "./components/Layout";
import SuspanceLoading from "./components/SuspanceLoading";
import ProtectedRoutes from "./components/ProtectedRoutes";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

function App() {
  return (
    <Layout>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <Suspense fallback={<SuspanceLoading />}>
          <ProtectedRoutes />
        </Suspense>
      </LocalizationProvider>
    </Layout>
  );
}

export default App;

//access_new_task_btn
//access_privat_task_input
//access_add_task_list
//access_add_task_type
